module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-sentry/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://05181434c867424b8f926a899f81d9fb@sentry.io/1273462","environment":"production","release":"22d76ea34f89e4563c8ffa612d8cf355117de692","whitelistUrls":[{}],"ignoreUrls":[{},{},{},{}]},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-5L53B23","includeInDevelopment":true,"gtmAuth":"EVDuWwNLKA2rcSXLDCCuZA","gtmPreview":"env-2"},
    },{
      plugin: require('../node_modules/gatsby-plugin-twitter/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
